import { Injectable } from '@angular/core';
import { Actions, Effect, ofType } from '@ngrx/effects';
import { Store } from '@ngrx/store';
import { of } from 'rxjs';
import { catchError, mergeMap, switchMap } from 'rxjs/operators';
import { IDocLog } from 'src/app/shared/models/doc-log/doc-log';
import * as docLogsActions from '../actions/doc-logs-actions';
import { ApiService, IPaginatedResult } from './../../shared/services/api-service/api-service';

const ETL_USER_ID = 'X4tyiuhAJ9p93fx'; // _id for Etl User on staging & prod (JE)

interface IAction {
  type: string;
  payload: {
    schoolId: string;
    studentId: string;
  };
}

@Injectable()
export class DocLogsEffects {
  constructor(private actions$: Actions, private apiService: ApiService, private store$: Store<any>) {}

  @Effect()
  loadDocLogs$ = this.actions$.pipe(
    ofType(docLogsActions.LOAD_DOC_LOGS),
    switchMap((action: IAction) => {
      const { schoolId, studentId } = action.payload;
      const options = {
        page: 1,
        limit: 10, // extra allows history panel to know if more than 3 are available (JE)
        where: JSON.stringify({
          'createdBy.userId': { $ne: ETL_USER_ID },
          studentId,
          historyType: { $ne: null },
        }),
      };
      return this.apiService.getPaginatedDocLogs(schoolId, options).pipe(
        mergeMap((res: IPaginatedResult<IDocLog>) => {
          return [new docLogsActions.LoadDocLogsSuccess(res.data)];
        }),
        catchError(error => {
          return of(new docLogsActions.LoadDocLogsFail(error));
        }),
      );
    }),
  );
}
